import { store } from '../../../redux/store';
import GetBasicDetails from '../GetBasicDetails';
import {
    CD,
    CD_USA_LEGAL_ENTITY,
    DIALING_CODE_PRESENT_FOR_LE,
    DIALING_COUNTRY_CODE_ORG_MAPPING,
} from '../Constants/Constants';
import { AffiliateDetailsAttributes } from '../../types/AffiliateDetails';
import { CheckUSAOrCanadaAffiliate } from '../CheckUSAOrCanadaAffiliate/CheckUSAOrCanadaAffiliate';
import { GetDialingCodeObjectAsPerCountryCode } from '../GetCountriesData';

export type DialingCodeObj = {
    dialingCode: string,
    displayName: string
};

export const GetDialingCode = (orgCode: string | null = null) => {
    const { user } = store.getState();
    const isUSAOrCanadaAffiliate: boolean = CheckUSAOrCanadaAffiliate();
    const { organisationCode } = GetBasicDetails();

    let currentOrgCode: string = organisationCode;

    if (user.affiliateDetails !== null) {
        const affiliateDetails: AffiliateDetailsAttributes = user?.affiliateDetails;
        const legalEntity: string = affiliateDetails?.affiliate?.legal_entity;
        const haveDialingCodeForLE: boolean = DIALING_CODE_PRESENT_FOR_LE.includes(legalEntity);
        currentOrgCode = isUSAOrCanadaAffiliate ? CD_USA_LEGAL_ENTITY[legalEntity] :
            haveDialingCodeForLE ? legalEntity : organisationCode;
    } else if (orgCode !== null) {
        currentOrgCode = orgCode
    }
console.log("currentOrgCode",currentOrgCode);
    const dialingCodeObj: DialingCodeObj = GetDialingCodeObjectAsPerCountryCode(DIALING_COUNTRY_CODE_ORG_MAPPING[currentOrgCode ?? CD]);

    return dialingCodeObj;
};

